export default __webpack_public_path__ + "static/media/logo-stb-2x.a4d4b820.png";